"use strict";
exports.__esModule = true;
exports.ConsumerReservationPatchType = exports.ReservationResponseType = void 0;
var ReservationResponseType;
(function (ReservationResponseType) {
    ReservationResponseType["Accepted"] = "ACCEPTED";
    ReservationResponseType["Rejected"] = "REJECTED";
})(ReservationResponseType = exports.ReservationResponseType || (exports.ReservationResponseType = {}));
var ConsumerReservationPatchType;
(function (ConsumerReservationPatchType) {
    ConsumerReservationPatchType["ConsumerPushToken"] = "consumerPushToken";
    ConsumerReservationPatchType["RespondToReservation"] = "respondToReservation";
    ConsumerReservationPatchType["WaiterMarkAsFinal"] = "waiterMarkAsFinal";
})(ConsumerReservationPatchType = exports.ConsumerReservationPatchType || (exports.ConsumerReservationPatchType = {}));
